<div #root class="stf">
  <div class="stf__save">
    <button
      #trigger
      type="button"
      class="stf__save-trigger"
      [disabled]="!canSave()"
      [attr.aria-expanded]="open()"
      aria-haspopup="true"
      aria-controls="stf-save-popover"
      (click)="toggle()"
    >
      <span class="stf__star" aria-hidden="true">★</span>
      {{ 'requirements.testCases.savedFilters.saveTrigger' | translate }}
    </button>

    @if (open()) {
      <div
        id="stf-save-popover"
        class="stf__popover"
        role="group"
        [attr.aria-label]="'requirements.testCases.savedFilters.saveTrigger' | translate"
      >
        <input
          #nameField
          class="stf__popover-input"
          type="text"
          maxlength="80"
          pattern="[^/?#]*"
          [attr.placeholder]="'requirements.testCases.savedFilters.namePlaceholder' | translate"
          [value]="nameInput()"
          (input)="onNameInput($event)"
          (keydown)="onSaveKey($event)"
        />
        <button type="button" class="stf__popover-save" [disabled]="!canPersist()" (click)="save()">
          {{ 'requirements.testCases.savedFilters.saveButton' | translate }}
        </button>
      </div>
    }
  </div>

  @if (filters().length > 0) {
    <div class="stf__chips" role="list">
      @for (filter of filters(); track filter.id) {
        <span class="stf__chip" [class.stf__chip--active]="activeName() === filter.name" role="listitem">
          <button
            type="button"
            class="stf__chip-label"
            [attr.aria-pressed]="activeName() === filter.name"
            (click)="onSelect(filter)"
          >
            {{ filter.name }}
          </button>
          <button
            type="button"
            class="stf__chip-delete"
            [attr.aria-label]="'requirements.testCases.savedFilters.deleteAria' | translate: { name: filter.name }"
            (click)="onDelete($event, filter.name)"
          >
            ×
          </button>
        </span>
      }
    </div>
  }
</div>
